<template>
  <div class="bg-wellLaboHeader text-white">
    <layouts-auth-width>
      <div class="p-2 h-14 grid grid-cols-2 content-center">
        <a :href="wellLaboUrl">
          <div class="col-span-2 flex items-center justify-center well_labo-title cursor-pointer">
            <base-icon-text class="transition-bounce mr-1" iconClass="text-wellLabo" :path="mdiPlayCircle"/>
            <h1 style="font-size: 1.2rem; display: inline-block; color: white;">
              WELL LABO
            </h1>
          </div>
        </a>
        <div class="col-span-2 flex items-center justify-end">
          <div class="mr-4">
            <router-link to="/account">
              <div class="flex justify-center">
                <base-icon-text class="transition-bounce mr-1" :path="mdiCog"/>
                <span>設定</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </layouts-auth-width>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiCog, mdiPlayCircle } from '@mdi/js'
import { HOME_PATH } from '@/router/routes'

import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: {
    LayoutsAuthWidth,
    BaseIconText
  },
  props: {
    is_well_labo: {
      type: Boolean
    }
  },
  setup(props) {
    const { t } = useI18n()
    const store = useStore()

    return {
      t,
      store,
      mdiCog,
      mdiPlayCircle,
      homePath: HOME_PATH,
      wellLaboUrl: process.env.VUE_APP_WELL_LABO_URL,
      props,
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.well_labo-title {
    float: left;
    margin-left: 20px;
    margin-right: 15px;
    position: absolute;
    top: 25%;
    vertical-align: middle;
}
.well_labo-title .label {
    font-weight: bold;
    font-size: 1.0rem;
    color: white;
    letter-spacing: 0px;
    font-family: "Helvetica Neue",Arial,"Hiragino Kaku Gothic ProN","Hiragino Sans",Meiryo,sans-serif;
    text-shadow: 2px 2px 2px #1d1d1d, 0 0 1em white, 0 0 0.5em #1d1d1d;
}
@media (max-width: 991px) {
    .well_labo-title .label {
    font-size: 0.76rem;
}
}
</style>
